import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {Step, StepContent, StepLabel, Typography, withStyles} from '@material-ui/core';
import styles from './styles';
import {withTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {StepperIcon} from '../index';
import classNames from 'classnames';
import {DateService} from '../../../../../services/util/DateService';
import moment from 'moment';
import {ExpandLess, ExpandMore} from '@material-ui/icons';


const TourEndStep = (props) => {
  const {className, classes, t, tour} = props;

  const [active, setActive] = useState(false);
  const rootClassName = classNames(classes.root, className);

  return (
    <Step
      active={active}
      className={rootClassName}
      completed
    >
      <StepLabel
        classes={{error: classes.noErrorClass}}
        StepIconComponent={StepperIcon}
      >
        <div
          className={classes.stepperLabel}
          onClick={() => setActive(!active)}
        >
          <Typography
            variant={'subtitle1'}
          >
            {`[${DateService.displayDateTime(tour.tourEnd)}] - ${t('tourEnd')}`}
          </Typography>
          {active ? <ExpandLess/> : <ExpandMore/>}
        </div>
      </StepLabel>
      <StepContent>
        <Typography>
          <strong>{t('plannedTourEnd')}:</strong> {DateService.displayDateTime(moment(tour.planedTourDelivery).add(tour.duration, 'minutes').toDate().toJSON())}
        </Typography>
        <Typography><strong>{t('plannedDuration')}:</strong> {tour.duration}</Typography>
        <Typography>
          <strong>{t('differenceActualAndPlannedTourEnd')}:</strong> {moment.duration(moment(tour.tourEnd).diff(moment(tour.planedTourDelivery).add(tour.duration, 'minutes'))).format('h:mm:ss', {trim: false})}
        </Typography>
        <Typography><strong>{t('actualDuration')}:</strong> {Math.round(moment.duration(moment(tour.tourEnd).diff(moment(tour.tourStart))).asMinutes())}
        </Typography>
      </StepContent>
    </Step>
  );
};


TourEndStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  tour: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withTranslation())(TourEndStep);
